import * as React from 'react';
import {Container, Paper} from "@mui/material";
import ResponsiveAppBar from "../../componets/header/header";
import Typography from "@mui/material/Typography";
import {Add, Export, Report} from "../../assets/images";
import { Link } from 'react-router-dom';
// import './paneñl.css';

function Panel() {
    return (
        <>
            <Container maxWidth="xl" className="contLayout mt-30">
                <Typography variant="h1" className="titleBody txt-dark" gutterBottom>Inicio</Typography>
                <Typography variant="h2" className="subtitleBody txt-green" gutterBottom>panel de configuración</Typography>

                <div className="cont-btn-Panel mt-50">
                    <Link to="/agregar-vehiculo" className={"link-panel"}>
                    <Paper elevation={3} className="bg-green pd-25 btn-panel">
                        <div className="cont-txt-btn-panel">
                            <img src={Add} alt=""/>
                            <div>
                                <p className="txt-btn-panel-1">Agregar</p>
                                <p className="txt-btn-panel-2">Vehiculo</p>
                            </div>
                        </div>
                    </Paper>
                    </Link>
                    <Link to="/operacion-tour" className={"link-panel"}>
                    <Paper elevation={3} className="bg-green pd-25 btn-panel">
                        <div className="cont-txt-btn-panel">
                            <img src={Report} alt=""/>
                            <div>
                                <p className="txt-btn-panel-1">Agregar</p>
                                <p className="txt-btn-panel-2">Operación</p>
                            </div>
                        </div>
                    </Paper>
                    </Link>
                    <Link to="/exportar-reportes" className={"link-panel"}>
                    <Paper elevation={3} className="bg-green pd-25 btn-panel">
                        <div className="cont-txt-btn-panel">
                            <img src={Export} alt=""/>
                            <div>
                                <p className="txt-btn-panel-1">Exportar</p>
                                <p className="txt-btn-panel-2">Reportes</p>
                            </div>
                        </div>
                    </Paper>
                    </Link>
                </div>
            </Container>
        </>
    );
}

export default Panel;
